import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { Link } from 'react-router-dom';
import constants from '@constants';
import { ActionGrid, ActionGridAction } from '@components';

class Counts extends Component {
	shouldComponentUpdate({
		activePage,
		search,
		loadingCounts,
		counts,
		router,
	}) {
		const lastProps = this.props;

		return (
			!isEqual(activePage, lastProps.activePage)
			|| !isEqual(search, lastProps.search)
			|| !isEqual(loadingCounts, lastProps.loadingCounts)
			|| !isEqual(counts, lastProps.counts)
			|| !isEqual(router, lastProps.router)
		);
	}

	getUrl = (viewType) => {
		const {
			activePage,
			search,
		} = this.props;

		if (viewType === 'needApproval') return `/jobs/list/${viewType}${search}`;

		return `/jobs/${activePage}/${viewType}${search}`;
	}

	render() {
		const {
			router : { match },
			loadingCounts,
			counts,
		} = this.props;
		let viewType = 'active';
		// RKP-1561: If the router's match provides a viewType, set it here. Otherwise, leave viewType as "active"
		if (match && match.params && match.params.viewType) {
			({ params : { viewType } } = match);
		}

		return (
			<ActionGrid className="margin-top-40">
				<For
					index="index"
					each="item"
					of={constants.JOB_TYPES_MAP}
				>
					<ActionGridAction
						key={`actionGrid_action_${index}`}
						url={this.getUrl(item.viewType)}
						active={item.viewType === viewType}
						disabled={loadingCounts}
						displayName={item.displayName}
						description={item.description}
						count={counts[item.countKey]}
						loading={loadingCounts}
						linkComponent={Link}
					/>
				</For>
			</ActionGrid>
		);
	}
}

const mapStateToProps = ({
	router : {
		location : { pathname, search },
		...router
	},
	jobs    : {
		counts,
		loaders : {
			counts : loadingCounts,
		},
	},
}) => ({
	router,
	search,
	loadingCounts,
	counts,
	activePage : pathname.split('/')[2],
});

Counts.propTypes = {
	activePage    : PropTypes.string,
	counts        : PropTypes.object,
	loadingCounts : PropTypes.bool,
	search        : PropTypes.string,
	router        : PropTypes.object,
};

Counts.defaultProps = {
	activePage    : '',
	counts        : {},
	loadingCounts : false,
	search        : '',
	router        : {},
};

export default connect(mapStateToProps)(Counts);
